import React, { useEffect, useState } from "react";
import PaginationControls from "./PaginationControls";

const ITEMS_PER_PAGE = 16;

function matchesStudent(record, searchTerm) {
  const term = searchTerm.toLowerCase();
  const studentIdStr = String(record.student_id || "").toLowerCase();
  const studentStr = (record.student_string || "").toLowerCase();
  return studentStr.includes(term) || studentIdStr.includes(term);
}

export default function ReceiptManageModal({
  isOpen,
  isLive,
  selectedMonth,
  receipts,
  onClose,
  onPrint,
}) {
  const [searchTerm, setSearchTerm] = useState("");
  const [page, setPage] = useState(1);

  useEffect(() => {
    if (!isOpen) return;
    setSearchTerm("");
    setPage(1);
  }, [isOpen, selectedMonth, isLive]);

  if (!isOpen) return null;

  const filteredReceipts = receipts.filter((receipt) => matchesStudent(receipt, searchTerm));
  const totalPages = Math.ceil(filteredReceipts.length / ITEMS_PER_PAGE);
  const paginatedReceipts = filteredReceipts.slice(
    (page - 1) * ITEMS_PER_PAGE,
    page * ITEMS_PER_PAGE
  );

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
      <div className="bg-white p-6 rounded-lg w-11/12 max-w-5xl max-h-screen overflow-y-auto">
        <h3 className="text-xl font-semibold mb-4">Receipts for {selectedMonth}</h3>
        <div className="mb-4 flex">
          <input
            type="text"
            placeholder="Search by student name or ID..."
            className="border p-2 rounded mr-2 w-1/3"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>
        <table className="min-w-full bg-white border border-gray-200">
          <thead>
            <tr className="bg-gray-200">
              <th className="px-4 py-2 border">Invoice Ref</th>
              <th className="px-4 py-2 border">Student</th>
              <th className="px-4 py-2 border">Total</th>
              <th className="px-4 py-2 border">Discount</th>
              <th className="px-4 py-2 border">Final Amount</th>
              <th className="px-4 py-2 border">Actions</th>
            </tr>
          </thead>
          <tbody>
            {paginatedReceipts.map((rc) => {
              const discount = Number(rc.discount || 0);
              const total = Number(rc.total_amount || 0);
              const finalAmount = Math.max(0, total - discount);

              return (
                <tr key={rc.receipt_ref || rc.invoice_ref || rc.student_id}>
                  <td className="px-4 py-2 border">{rc.invoice_ref || "N/A"}</td>
                  <td className="px-4 py-2 border">
                    {rc.student_string || `ID: ${rc.student_id}`}
                  </td>
                  <td className="px-4 py-2 border text-right">${total.toFixed(2)}</td>
                  <td className="px-4 py-2 border text-right">
                    {discount > 0 ? `$${discount.toFixed(2)}` : "-"}
                  </td>
                  <td className="px-4 py-2 border text-right font-medium">
                    ${finalAmount.toFixed(2)}
                  </td>
                  <td className="px-4 py-2 border">
                    <button
                      onClick={() => onPrint(rc)}
                      className="bg-blue-500 text-white px-3 py-1 rounded hover:bg-blue-600"
                    >
                      Print Receipt
                    </button>
                  </td>
                </tr>
              );
            })}
            {paginatedReceipts.length === 0 && (
              <tr>
                <td colSpan={6} className="text-center py-4">
                  No receipts found for {selectedMonth}.
                </td>
              </tr>
            )}
          </tbody>
        </table>
        <PaginationControls page={page} totalPages={totalPages} onPageChange={setPage} />
        <button
          onClick={onClose}
          className="mt-4 bg-gray-500 text-white px-4 py-2 rounded hover:bg-gray-600"
        >
          Close
        </button>
      </div>
    </div>
  );
}
